module.exports = {"150922103":"化德县长顺镇","150922104":"化德县朝阳镇","150922105":"化德县七号镇","150922200":"化德县德包图乡","150922201":"化德县公腊胡洞乡","150922218":"化德县白音特拉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150922.json
// module id = 422
// module chunks = 0